var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68624 27.7444C5.35743 28.4156 6.07356 29.0142 6.82474 29.5412L29.1104 7.2555C28.5835 6.50431 27.9849 5.78819 27.3137 5.117C26.6424 4.44581 25.9264 3.84731 25.1752 3.32031L2.88962 25.606C3.41649 26.357 4.01512 27.0732 4.68624 27.7444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68661 5.11671C-0.361017 10.1645 -1.33008 17.7451 1.77761 23.7666L23.3365 2.20777C17.315 -0.899917 9.7343 0.0692077 4.68661 5.11671Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 27.7446C32.3613 22.697 33.3303 15.1162 30.2228 9.09473L8.66388 30.6536C14.6852 33.7613 22.266 32.7922 27.3137 27.7446Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTanzania);
export default __webpack_public_path__ + "static/media/flag_tanzania.f6b3674a4b2bee2e208b112396206577.svg";
export { ForwardRef as ReactComponent };